
import React from 'react';
import './policies.css';

function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Privacy Policy</h1>

        <p className="last-updated">
          Last Updated: June 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            At <strong>Mr White</strong>, we are committed to protecting your privacy.
            This Privacy Policy outlines how we collect, use, disclose, and manage
            your personal information.
          </p>
        </div>

        <div className="policy-section">
          <h2>1. Information Collection</h2>
          <p>
            We may collect personal information, including but not limited to
            your name, email address, phone number, and details related to your
            laundry orders for the purpose of providing our services effectively.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Payment Information</h2>
          <p>
            All credit/debit card details and personal information will NOT be
            stored, sold, shared, rented, or leased to any third parties.
          </p>

          <p>
            We use secure payment processing systems to handle transactions,
            ensuring your financial data is protected.
          </p>
        </div>

        <div className="policy-section">
          <h2>3. Use of Information</h2>
          <p>
            We may use your information to:
          </p>

          <ul className="policy-list">
            <li>Process and manage your orders.</li>
            <li>Send you updates regarding your service.</li>
            <li>Improve our services and user experience.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Disclosure of Information</h2>

          <p>
            Your personal information may be disclosed:
          </p>

          <ul className="policy-list">
            <li>
              To trusted service providers who assist us in operating our
              business (e.g., laundry partners), under strict confidentiality.
            </li>
            <li>
              If required by law or in response to legal requests.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Changes to This Privacy Policy</h2>

          <p>
            Our Privacy Policy, along with our Terms & Conditions, may be
            updated occasionally to meet changing requirements and standards.
          </p>

          <p>
            Users will be notified via email or through our website/app
            regarding any significant changes.
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Your Consent</h2>

          <p>
            By using our services, you consent to our Privacy Policy.
            If you do not agree with this policy, please refrain from using
            our services.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Contact Us</h2>

          <p>
            If you have any questions or concerns about this Privacy Policy
            or our data practices, please contact us at:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default PrivacyPolicy;

